import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {createFrom, EventService, Page} from '@spartacus/core';
import {isPlatformBrowser} from '@angular/common';
import {ErrorPageEvent} from './error-page-event';
import {Observable} from 'rxjs';
import {NavigationEvent, PageLayoutService} from '@spartacus/storefront';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {filter, first, map, switchMap} from 'rxjs/operators';
import {ErrorPageMissingEvent} from './error-page-missing-event';
import {NavigationComponentService} from '@app/services/navigation-component.service';

const MISSING_PAGE_ERROR_TYPE = '404';
const MISSING_PAGE_ID = 'notFound';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class ErrorPageMissingEventService {
  constructor(
    @Inject(PLATFORM_ID) public platformId: string,
    protected eventService: EventService,
    protected pageLayoutService: PageLayoutService,
    protected navigationService: NavigationComponentService
  ) {
    this.register();
  }

  protected register(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.eventService.register(ErrorPageMissingEvent, this.buildErrorPageMissingEvent());
  }

  protected buildErrorPageMissingEvent(): Observable<ErrorPageMissingEvent> {
    return this.eventService.get<NavigationEvent>(NavigationEvent).pipe(
      untilDestroyed(this),
      switchMap((navigationEvent) =>
        this.pageLayoutService.page$.pipe(
          untilDestroyed(this),
          first(),
          map((page) => ({navigationEvent, page}))
        )
      ),
      filter(({navigationEvent, page}) => this.isPageErrorTemplate(navigationEvent, page)),
      map(({navigationEvent, page}) => {
        const errorEvent = {
          navigation: navigationEvent,
          errorType: MISSING_PAGE_ERROR_TYPE,
          description: page.name,
          pageSection:
            navigationEvent.url != null ? this.navigationService.getSectionFromUrl(navigationEvent.url) : '/',
        } as ErrorPageEvent;
        return createFrom(ErrorPageMissingEvent, errorEvent);
      })
    );
  }

  protected isPageErrorTemplate(navigationEvent: NavigationEvent, page: Page): boolean {
    if (navigationEvent.semanticRoute) {
      return false;
    }
    return page.pageId === MISSING_PAGE_ID;
  }
}
